import request from '@/utils/request.js'
import qs from 'qs';


/***  封装请求方法  ***/
export function wxRequest(url, data, method){
    let obj = {};
    if(method=="get"){
        obj = {
            url: url,
            method: method,
            params: data,
        }
    }else if(method=="post"){
        obj = {
            url,
            method,
            data,
        }
    }
    return request(obj)
}
